import { useI18n } from '~/common/context';
import { SwitchField as BaseSwitchField, SwitchFieldProps } from '@wyz/ui';
import * as React from 'react';

const SwitchField: React.FC<SwitchFieldProps> = (props) => {
  const { t } = useI18n();

  return <BaseSwitchField {...props} translate={t} />;
};

export default SwitchField;
